import { GET } from './utils';

export const GET_KNOWLEDGE_DOCUMENT = ({ knowledgeId }) => GET({ url: `knowledge/${knowledgeId}` });
